module.exports = __webpack_public_path__ + "img/kronospan-logo.59cb6e80.jpg";